import { render, staticRenderFns } from "./DigitalTransform.vue?vue&type=template&id=20f642df"
import script from "./DigitalTransform.vue?vue&type=script&lang=js"
export * from "./DigitalTransform.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/AzDevOps/myagent/_work/11/s/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('20f642df')) {
      api.createRecord('20f642df', component.options)
    } else {
      api.reload('20f642df', component.options)
    }
    module.hot.accept("./DigitalTransform.vue?vue&type=template&id=20f642df", function () {
      api.rerender('20f642df', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/trans/DigitalTransform.vue"
export default component.exports